var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.766,
    cy: 47.2656,
    r: 46.3491,
    fill: "#EEF0F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_873_1916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7663 14.1707C37.8936 14.1707 30.634 21.656 30.634 30.8791C30.634 40.1022 37.8936 47.5876 46.7663 47.5876C55.6391 47.5876 62.8986 40.1022 62.8986 30.8791C62.8986 21.656 55.6391 14.1707 46.7663 14.1707ZM29.9081 47.5876C21.3579 47.9217 14.5017 53.7363 14.5017 60.9543V67.6377H79.0309V60.9543C79.0309 53.7363 72.2554 47.9217 63.6246 47.5876C59.2689 51.6644 53.2999 54.271 46.7663 54.271C40.2327 54.271 34.2638 51.6644 29.9081 47.5876Z",
    fill: "#8D8D8D",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_873_1916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.5292,
    height: 53.4671,
    fill: "white",
    transform: "translate(14.5017 14.1707)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/default_profile.d2bce10a2378699bd7dfa6a325df756b.svg";
export { ForwardRef as ReactComponent };